<div class = "flex justify-center h-screen">
    <div class = "m-10">
        <h1>About</h1>
        <p>Hi, I'm Corman! I'm thirteen, and I really enjoy coding.</p>
        <p>If you want to know more about me, you can check out my <a href = "https://linktr.ee/Cormans">link tree</a> for info on my Discord, Twitter, and etc.</p>
    </div>
</div>